import { render } from "./catalog.cattle.io.clusterrepo.vue?vue&type=template&id=21cfc5c8&scoped=true"
import script from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=js"
export * from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=js"

import "./catalog.cattle.io.clusterrepo.vue?vue&type=style&index=0&id=21cfc5c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cfc5c8"]])

export default __exports__